import { Dimensions } from 'react-native';

const { width, height } = Dimensions.get('window');

// Define your constants based on screen dimensions
const dimensions = {
  windowHeight: height,
  windowWidth: width,
  // Define padding values based on screen width
  paddingHorizontal: width * 0.05,
  paddingVertical: height * 0.024,

  //margin
  marginHorizontal: width * 0.05,
  marginVertical: height * 0.01,

  windowHeight: height,
  windowWidth: width,
};

export default dimensions;
